import { render } from "./HtmlTab.vue?vue&type=template&id=2e0d1d26&scoped=true"
import script from "./HtmlTab.vue?vue&type=script&lang=js"
export * from "./HtmlTab.vue?vue&type=script&lang=js"

import "./HtmlTab.vue?vue&type=style&index=0&id=2e0d1d26&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0d1d26"]])

export default __exports__